import React, { useContext } from 'react'
import { useFormikContext } from 'formik'
import { Cell, Switch } from 'react-foundation'
import UserContext from '../../UserContext'
import { SaveEvent, CheckboxEvent } from '../Common/AnalyticsEvents'

type Option = { label: string; value: boolean };

type Group = {
  label: string;
  enabled: boolean;
  options: Record<string, Option>;
};

type EmailPrefs = Record<string, Group>;

export const EmailNotificationPreferences: React.FC = () => {
  const user = useContext(UserContext)
  const { values, setFieldValue } = useFormikContext<{ emailCommunicationPreferences: EmailPrefs, communicationMethods: string[] }>();
  const emailPrefs = values.emailCommunicationPreferences || {};
  const selectedCommunicationMethods = values.communicationMethods || [];
  const handleTopLevelSwitch = (groupKey: string, checked: boolean) => {
    setFieldValue(`emailCommunicationPreferences.${groupKey}.enabled`, checked);
    SaveEvent(CheckboxEvent(user, 'CM Email Notification Preferences', emailPrefs[groupKey]?.label ?? groupKey, checked))
    if (!checked) {
      const options = emailPrefs[groupKey].options;
      Object.keys(options).forEach(optKey => {
        setFieldValue(`emailCommunicationPreferences.${groupKey}.options.${optKey}.value`, false);
      });
    }
    // If turning ON, do not touch sub-switches
  };

  return (
    <Cell className="switch-group-container">
        {Object.entries(emailPrefs).map(([groupKey, group]) => (
            <Cell key={groupKey} className="switch-card">
                <Cell style={{ display: 'flex', alignItems: 'center', marginBottom: '1em' }}>
                    <Switch
                        input={{
                        name: `emailCommunicationPreferences.${groupKey}.enabled`,
                        checked: group.enabled,
                        disabled: selectedCommunicationMethods.length === 0,
                        onChange: (e: React.ChangeEvent<HTMLInputElement>) =>
                            handleTopLevelSwitch(groupKey, e.target.checked),
                        }}
                    />
                    <span style={{ marginLeft: '1em', fontWeight: 600 }}>{group.label}</span>
                </Cell>
            </Cell>
        ))}
    </Cell>
  );
};